import OperationService from '../services/operation.service'

export const operationModule = {
  namespaced: true,

  state: {
     operationDetail: null,
     operation: null
  },

  actions: {
    async detail ({ commit }, criterias) {
      return OperationService.detail(criterias).then(
        response => {
          const operationDetail = response.data
          commit('detailSuccess', operationDetail)
          return Promise.resolve(operationDetail)
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async detailReset ({ commit }) {
      commit('detailReset')
    },

    async setOperation ({ commit }, operation) {
      commit('operationSuccess', operation)
    }
  },

  mutations: {
    detailSuccess (state, operation) {
      state.operationDetail = operation
    },
    detailFailure (state) {
      state.operationDetail = null
    },
    detailReset (state) {
      state.operationDetail = null
    },
    operationSuccess (state, operation) {
      state.operation = operation
    }
  }
}
